// @ts-nocheck
/* eslint-disable */

import type { Error } from '../models/error';
import { isEmpty } from 'lodash';
import * as EmailValidator from 'email-validator';

type RowObj = { false?: string };
type EmailObj = { [key: string]: object };

type Status = {
  email: string;
  is_managed: boolean;
};

type Record = {
  _id?: string;
  id?: string;
  email: string;
  first_name?: string;
  last_name?: string;
  role_id?: string;
  valid?: boolean;
  existing_user?: boolean;
  errors?: Error[] | string[];
  is_managed?: boolean;
};

// Updates a record in an array by matching _id property
export const updateRecord = (records: Record[], updated: Record) => {
  // normalizes array to an object
  const toObj = (arr: Record[]) => {
    return arr.reduce((acc: object, curr: Record) => {
      if (!acc[curr._id]) {
        acc[curr._id] = curr;
      }
      return acc;
    }, {});
  };

  const recordsObj = toObj(records);

  const updateRecords = (obj: object) => (record: Record) => {
    const { role_id, email, first_name, last_name, _id, valid, existing_user, errors } = record;

    if (obj[record._id]) {
      obj[record._id] = { email, first_name, last_name, role_id, _id, valid, existing_user, errors };
    }

    return Object.keys(obj).map(e => obj[e]);
  };

  const result = updateRecords(recordsObj)(updated);
  return result;
};

export const hasErroredRow = (rows: Record[]) => {
  const toObj = (arr: Record[]) => {
    return arr.reduce((acc: RowObj, curr: Record) => {
      const status = curr.valid.toString();

      if (!acc[status]) {
        acc[status] = curr;
      }
      return acc;
    }, {});
  };

  const rowsObj = toObj(rows);

  if (rowsObj.false) {
    return true;
  }
  return false;
};

export const getEmails = (rows: Record[]) => {
  const emailsObj: EmailObj = toObjEmail(rows);
  return Object.keys(emailsObj);
};

const formatNumber = (number: number) => Number((number / 100).toFixed(2));
export const formatCurrency = (num: number) => {
  const formattedNumber = formatNumber(num);

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(formattedNumber);
};

export const formatMembers = (members: Record[]) => {
  members.forEach(member => {
    member.first_name = removeSpaces(member.first_name);
    member.last_name = removeSpaces(member.last_name);
    member.email = member.email.trim();
  });
  return members;
};

export const membersHavePermissions = ({ result, permissions, selectedPermissions }) => {
  const confirmMessage = 'Are you sure you don\'t want to assign any permissions?';

  const { forms, projects, layers, groups } = permissions;
  const { selectedForms, selectedProjects, selectedLayers, selectedGroups } = selectedPermissions;

  if (isEmpty(selectedLayers) && isEmpty(selectedForms) && isEmpty(selectedProjects) && isEmpty(selectedGroups)) {
    if (!isEmpty(forms) || !isEmpty(projects) || !isEmpty(layers) || !isEmpty(groups)) {
      result = confirm(confirmMessage); // eslint-disable-line no-alert
    }
  }

  return result;
};

// returns duplicates from an array of strings
export const getDuplicates = (items: string[]) => {
  return items.filter((e, i, arr) => arr.indexOf(e) !== i);
};

export const getDuplicatesByManaged = (allEmails: string[], existing: Record[], managed: boolean) => {
  const duplicateEmails = getDuplicates(allEmails);

  if (existing && duplicateEmails.length > 0) {
    const existingConverted = convert(existing);

    const duplicates = existingConverted.reduce((acc, curr) => {
      duplicateEmails.forEach(dupe => {
        if (curr.email === dupe && curr.is_managed === managed) {
          acc.push(curr);
        }
      });
      return acc;
    }, []);

    const scopeDuplicates = Object.keys(toObjEmail(duplicates));
    return scopeDuplicates;
  }
  return [];
};

const convert = (users: Record[]): Status[] => {
  return users.map(user => ({
    email: typeof user === 'string' ? user : user.email,
    is_managed: user.is_managed,
  }));
};

export const removeDuplicates = (arr1: string[], arr2: any) => {
  return arr2.filter(val => arr1.indexOf(val.email) === -1);
};

export const noUsersEntered = users => {
  const emptyUsers = users.reduce((acc, curr) => {
    if (isEmpty(curr.email) && isEmpty(curr.first_name) && isEmpty(curr.last_name)) {
      acc[curr._id] = curr;
    }

    return acc;
  }, []);

  return Object.keys(emptyUsers).map(e => e);
};

/**
 * HELPER METHODS
 */

// Reduces an array of objects with emails to an object with emails as keys
const toObjEmail = (arr: Record[]) => {
  return arr.reduce((acc, curr) => {
    if (!acc[curr.email]) {
      acc[curr.email] = curr;
    }
    return acc;
  }, {});
};

export function showError(err: { type: string; message: string }) {
  // eslint-disable-next-line no-alert
  alert(`Error: ${err.type}: ${err.message}`);
}

// Removes leading, trailing, and any more than a single space
export const removeSpaces = (s: string) => s.replace(/\s\s+/g, ' ').trim();

// Tests for valid email containing a single @ symbol
export const emailTest = (email: string): boolean => EmailValidator.validate(email);
/* eslint-disable */

export const waitForCallBackOrExpire = (
  callback: any,
  timeout: number,
): Promise<boolean> => new Promise((resolve, reject) => {
  const timeWas = new Date();
  const wait = setInterval(() => {
    if (callback()) {
      clearInterval(wait);
      resolve(true);
    } else if ((new Date().valueOf() - timeWas.valueOf()) > timeout) { // Timeout
      clearInterval(wait);
      // eslint-disable-next-line prefer-promise-reject-errors
      reject(`Callback expired after ${timeout} miliseconds.`);
    }
  }, 20);
});